import { Value } from './SelectionFilter';

export const filterValuesByText = <T>(valuesArray: Value<T>[], text: string) => {
  if (!text || text?.length < 1) {
    return valuesArray;
  }

  return valuesArray?.filter((value) => {
    return value?.label?.toLowerCase().includes(text.toLowerCase());
  });
};

export const createArrayCopy = <T>(values: Value<T>[]) => {
  return values?.map((obj) => ({ ...obj }));
};
